export let baseURL = "https://qtadmin.chinayounao.com"
// export let baseURL = "http://182.92.192.47:8082/ggwjt.api"
// export let baseURL = "http://182.92.192.47:10100"
// export let baseURL = "https://2016kt6872.oicp.vip"